module.exports = __webpack_public_path__ + "static/media/welcome-banner.4e523491.png";